import {Howl} from 'howler';

const createHowl = (options = {}) => {
	const sound = new Howl({
		...options,
		preload: false,
	});

	const play = sound.play.bind(sound);

	sound.play = (...args) => {
		if (sound._state === 'unloaded') {
			sound.load();
		}

		return play(...args);
	};

	return sound;
};

export default createHowl;
